
import React from "react";
import { Image } from "react-bootstrap";
import { push } from "react-router-redux";

export const makeUndefinedCompressor = cindex => ({
	cindex: cindex,
	technology: COMPRESSOR_TECHNOLOGY_NONE,
	type_plate: {}
});

const COMPRESSOR_TECHNOLOGY_NONE = 0;
//const COMPRESSOR_TECHNOLOGY_SCREW_FOREIGN = 1;
//const COMPRESSOR_TECHNOLOGY_PISTON_FOREIGN = 2;
//const COMPRESSOR_TECHNOLOGY_TURBO_FOREIGN = 3;
//const COMPRESSOR_TECHNOLOGY_SCREW_ALMIG = 4;
//const COMPRESSOR_TECHNOLOGY_PISTON_ALMIG = 5;
//const COMPRESSOR_TECHNOLOGY_TURBO_ALMIG = 6;

export const compressorNameOrNumber = (compressor) => (
	compressor
		? compressor.name || (compressor.cindex + 1).toString()
		: ""
);

export const compressorIsInstalled = (compressor) => (
	compressor && compressor.technology !== COMPRESSOR_TECHNOLOGY_NONE
);

const compressorIsForeign = (compressor) => (
	compressor.technology < 4
);

const image_file_technology = [ "none",
	/* Fremdkompressor */
	"schraube", "kolben", "turbo",
	/* ALMiG-Kompressor */
	"schraube", "kolben", "turbo"
];

const compressorImageFilename = (compressor) => (
	"/sym" + image_file_technology[compressor.technology] +
	(compressorIsForeign(compressor) ? "fremd" : "almig") +
	"59x59.png"
);

export const STATUS_NO_STATUS = 0;				// Kein Status
const STATUS_READY_MASK = 0x0001;				// Eingeschaltet und bereit
export const STATUS_MOTOR_MASK = 0x0002;		// Motor läuft
export const STATUS_ON_LOAD_MASK = 0x0004;		// Lastventil auf
//const STATUS_AWAL_OR_VORORT_MASK = 0x0008;	// ???
//const STATUS_NEW_ERROR_MASK = 0x0010;			// ???
const STATUS_MAINTENANCE_MASK = 0x0020;			// Wartung
const STATUS_WARNING_MASK = 0x0040;				// Warnung
export const STATUS_ERROR_MASK = 0x0080;		// Störung
const STATUS_STARTING_MASK = 0x0100;			// Hochlauf
const STATUS_RUN_ON_MASK = 0x0200;				// Nachlauf
//const STATUS_MANUAL_MASK = 0x4000;			// Handbetrieb
export const STATUS_COMM_ERROR_MASK = 0x8000;	// Kommunikationsstörung

export const compressorIsMotorOn = (compressor) => (
	compressor.status & STATUS_MOTOR_MASK
);

export const compressorIsOnLoad = (compressor) => (
	compressor.status & STATUS_ON_LOAD_MASK
);

const ERROR_TYPE_OK = 0;
const ERROR_TYPE_MAINTENANCE = 1;
const ERROR_TYPE_WARNING = 2;
const ERROR_TYPE_ERROR = 3;

const compressorErrorType = (compressor) => {
	var r = ERROR_TYPE_OK;
	if (compressor.status & STATUS_MAINTENANCE_MASK) {
		r = ERROR_TYPE_MAINTENANCE;
	}
	if (compressor.status & STATUS_WARNING_MASK) {
		r = ERROR_TYPE_WARNING;
	}
	if (compressor.status & STATUS_COMM_ERROR_MASK ||
		compressor.status & STATUS_ERROR_MASK) {
		r = ERROR_TYPE_ERROR;
	}
	return r;
};

const error_type_to_border_class = [ "Ok", "Maintenance", "Warning", "Error" ];

const compressorStatusImageClasses = compressor => (
	"StatusImage Border" +
	error_type_to_border_class[compressorErrorType(compressor)]
);

export const compressorStatusImage = compressor => (
	compressorIsInstalled(compressor)
		? <Image src={ compressorImageFilename(compressor) }
			className={ compressorStatusImageClasses(compressor) }/>
		: <div className="notInstalled"/>
);

export const DISPLAYED_STATUS_NOT_INSTALLED = 0;	// Kompressor ist der Steuerung nicht bekannt
const DISPLAYED_STATUS_OFF = 1;				// Kompressor ist aus
const DISPLAYED_STATUS_READY = 2;			// Kompressor ist bereit
const DISPLAYED_STATUS_STARTING = 3;		// Kompressor läuft hoch
const DISPLAYED_STATUS_OFF_LOAD = 4;		// Kompressor im Leerlauf
const DISPLAYED_STATUS_ON_LOAD = 5;			// Kompressor ist im Lastlauf
const DISPLAYED_STATUS_RUN_ON = 6;			// Kompressor läuft nach
const DISPLAYED_STATUS_MAINTENANCE = 7;		// Wartung fällig
const DISPLAYED_STATUS_WARNING = 8;			// Warnung liegt an
const DISPLAYED_STATUS_ERROR = 9;			// Fehler liegt vor
const DISPLAYED_STATUS_COMM_ERROR = 10;		// Kommunikation mit dem Kompressor ist gestört

export const compressorDisplayedStateIndex = compressor => {
	if (!compressor || !compressorIsInstalled(compressor)) {
		return DISPLAYED_STATUS_NOT_INSTALLED;
	}
	// Sonderzustände: CommError, Wartung, Warnung und Fehler
	if (compressor.status & STATUS_COMM_ERROR_MASK) {
		return DISPLAYED_STATUS_COMM_ERROR;
		// TODO: Steuerung meldet COMM_ERROR obwohl der Kompressor "nur" einen Fehler hat
		// 27.2.2018: hä, ist dieses TODO noch von Bedeutung?
	}
	if (compressor.status & STATUS_ERROR_MASK) {
		return DISPLAYED_STATUS_ERROR;
	}
	if (compressor.status & STATUS_WARNING_MASK) {
		return DISPLAYED_STATUS_WARNING;
	}
	if (compressor.status & STATUS_MAINTENANCE_MASK) {
		return DISPLAYED_STATUS_MAINTENANCE;
	}
	// Normale Zustände: Aus, Bereit, Hochlauf, Lastlauf, Nachlauf
	if (!(compressor.status & STATUS_READY_MASK)) {
		return DISPLAYED_STATUS_OFF;
	}
	if (!(compressor.status & STATUS_MOTOR_MASK)) {
		return DISPLAYED_STATUS_READY;
	}
	if (compressor.status & STATUS_STARTING_MASK) {
		return DISPLAYED_STATUS_STARTING;
	}
	if (compressor.status & STATUS_RUN_ON_MASK) {
		return DISPLAYED_STATUS_RUN_ON;
	}
	if (compressor.status & STATUS_ON_LOAD_MASK) {
		return DISPLAYED_STATUS_ON_LOAD;
	}
	return DISPLAYED_STATUS_OFF_LOAD;
};

export const compressorDisplayedStateTNR = compressor => (
	[ "Not installed", "Off", "Ready", "Starting", "No-load", "Load", "Run on",
		"Maintenance", "Warning", "Error", "Communication error" ][
		compressorDisplayedStateIndex(compressor)]
);

export const compressorIndexFromLocation = location_path => {
	let parts = location_path.split("/");
	let index = Number(parts[3]);
	return index;
};

//const BRANDING_ALMIG = 0;
//const BRANDING_KRAFTMANN = 1;
//const BRANDING_DALVA = 2;
//const BRANDING_UNKNOWN = 3;

//const ALMIG_TYPE_UNKNOWN = 0;
/*		Diese Werten werden bisher nicht verwendet ...
		
		public static const ALMIG_TYPE_VARIABLE:int = 1;
		public static const ALMIG_TYPE_GEAR:int = 2;
		public static const ALMIG_TYPE_DIRECT:int = 3;
		public static const ALMIG_TYPE_BELT:int = 4;
		public static const ALMIG_TYPE_FLEX:int = 5;
		public static const ALMIG_TYPE_LENTO:int = 6;
		public static const ALMIG_TYPE_COMBI:int = 7;
		public static const ALMIG_TYPE_COMBI_T:int = 8;
		public static const ALMIG_TYPE_SIMPLEXX:int = 9;
		public static const ALMIG_TYPE_DUPLEXX:int = 10;
		public static const ALMIG_TYPE_DYNAMIC:int = 11;
		public static const ALMIG_TYPE_V_DRIVE:int = 12;
		public static const ALMIG_TYPE_G_DRIVE:int = 13;
		public static const ALMIG_TYPE_V_DRIVE_T:int = 14;
		public static const ALMIG_TYPE_G_DRIVE_T:int = 15;
*/

export const compressorOnMotorImage = compressor => (
	compressorIsMotorOn(compressor)
		? <Image src="/symmotor25x25.png" className="MotorImage"/>
		: <div />
);

export const compressorOnLoadImage = compressor => (
	compressorIsOnLoad(compressor)
		? <Image src="/symventil34x25.png" className="VentilImage"/>
		: <div />
);

const image_fu_black = "/symFU32x32.png";
const image_fu_green = "/symFU32x32gruen.png";
const image_fu_red = "/symFU32x32rot.png";

export const compressorFuImageName = compressor => {
	return [
		undefined,		/* kein FU */
		image_fu_black,
		image_fu_green,
		image_fu_red
	][compressor.symbols & 0x3];
};

export const prevInstalledCompressorIndex = (location_path, compressors) => {
	let index = compressorIndexFromLocation(location_path) - 1;
	while (index >= 0 && index < compressors.length) {
		if (compressorIsInstalled(compressors[index])) {
			return index;
		}
		index -= 1;
	}
	return -1;
};

export const nextInstalledCompressorIndex = (location_path, compressors) => {
	let index = compressorIndexFromLocation(location_path) + 1;
	while (index < compressors.length) {
		if (compressorIsInstalled(compressors[index])) {
			return index;
		}
		index += 1;
	}
	return -1;
};

export const genChangeCompressorPath = dispatch => (
	(location_path, index) => {
		let parts = location_path.split("/");
		parts[3] = index.toString();
		dispatch(push(parts.join("/")));
	});

export const defaultCompressorPath = (state, prefix) => {
	let path = null;
	state.ablauf.compressors.forEach((compressor, index) => {
		if (!path && compressorIsInstalled(compressor)) {
			path = prefix + index;
		}
	});
	return path || prefix + 0;
};

export const compressorComponentToI18nKey = component => [
	"Water filter",
	"Suction filter",
	"Oil filter",
	"Oil separator",
	"Motor",
	"Compressor",
	"Dryer",
	"Universal 1",
	"Universal 2",
	"Universal 3",
	"Universal 4",
	"Annual maintenance"
][component];
